import React from 'react'
import { Images } from '../../../utils/imageConstants'
import type { ChatSession } from '../types'

interface ChatSidebarProps {
  isOpen: boolean
  chatSessions: ChatSession[]
  selectedChatId: string
  isLoading: boolean
  onNewChat: () => void
  onChatSelect: (chatId: string) => void
  onScroll: () => void
  sidebarScrollRef: React.RefObject<HTMLDivElement | null>
}

const ChatSidebar: React.FC<ChatSidebarProps> = ({
  isOpen,
  chatSessions,
  selectedChatId,
  isLoading,
  onNewChat,
  onChatSelect,
  onScroll,
  sidebarScrollRef
}) => {
  return (
    <div className={`statgpt-sidebar ${isOpen ? 'open' : 'closed'}`}>
      <div className="statgpt-fab" onClick={onNewChat} style={{ cursor: 'pointer' }}>
        <div className="statgpt-fab-state-layer">
          <div className="statgpt-fab-icon">
            <img src={Images.new_chat_icon} alt="New Chat" />
          </div>
          {isOpen && (
            <div className="statgpt-fab-text">New Chat</div>
          )}
        </div>
      </div>
      
      {isOpen && (
        <div 
          className="statgpt-chat-list"
          ref={sidebarScrollRef}
          onScroll={onScroll}
        >
          {chatSessions.map((chat) => (
            <div
              key={chat.sessionId}
              className={`statgpt-chat-item ${selectedChatId === chat.sessionId ? 'active' : ''}`}
              onClick={() => onChatSelect(chat.sessionId)}
            >
              <div className="statgpt-chat-item-content">
                <p className="statgpt-chat-item-text">{chat.thumbnailText}</p>
              </div>
            </div>
          ))}
          {isLoading && (
            <div className="statgpt-chat-loading">Loading...</div>
          )}
        </div>
      )}
    </div>
  )
}

export default ChatSidebar

